import React, { useMemo } from "react";
import cn from "classnames";
import queryString from "query-string";
import { useUI } from "../context";

export const Product = () => {
  const { activeStep } = useUI();
  const { products = [], page_settings = {} } = window.CONTACT_FORM;

  // return  null

  const { product = 1 } = queryString.parse(location.search);

  const productDetail = useMemo(() => {
    return products.find((i) => i.id == product);
  }, [product]);

  if (!productDetail) return (window.location.href = window.location.origin);

  return (
    <div
      className={cn("flex flex-col gap-9 sticky top-[100px]", {
        hidden: activeStep === 4,
      })}
    >
      <p className="text-text-light font-medium text-text-md">{page_settings.label_choose}</p>
      <a
        href={productDetail?.link}
        className="flex flex-col rounded-[10px] outline outline-1 outline-offset-0 outline-gray-modern-300 bg-white overflow-hidden"
      >
        <img src={productDetail?.image.url} alt="" className="aspect-[3/1] object-cover" />
        <p className="pt-2 pb-2.5 px-6 font-bold text-text-md text-gray-modern-800">
          {productDetail?.title}
        </p>
      </a>
    </div>
  );
};
